module.exports = __webpack_public_path__ + "img/waffles.f6d1eef8.png";